import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

type Col = {
        prop: string
        label: string
    }

    // eslint-disable-next-line no-undef
    
export default /*@__PURE__*/_defineComponent({
  __name: 'PaginatedTable',
  props: {
    data: {},
    loading: { type: Boolean },
    showRows: {},
    pages: {},
    page: {},
    cols: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {


    

    // eslint-disable-next-line no-undef
    const emit = __emit

    const change = (p: number) => {
        emit("change", p)
    }

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_skeleton, {
      animated: "",
      rows: __props.showRows,
      loading: __props.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: __props.data,
          height: 460,
          border: true,
          stripe: true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cols, (col) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                style: {"text-wrap":"nowrap !important"},
                "min-width": 100,
                key: col.prop,
                label: col.label,
                prop: col.prop
              }, null, 8, ["label", "prop"]))
            }), 128)),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["data"])
      ]),
      _: 3
    }, 8, ["rows", "loading"]),
    _createVNode(_component_el_pagination, {
      class: "p-2",
      "hide-on-single-page": "",
      total: __props.pages,
      "default-current-page": __props.page,
      "page-count": __props.pages,
      onChange: change
    }, null, 8, ["total", "default-current-page", "page-count"])
  ]))
}
}

})